import { useSelector } from "react-redux";
import { ISeminarTask, ISeminarTaskBlock } from "../../../../../../models/tasks";
import { IClasses } from "../../../../../../models/classes";
import TrackSelectionBlock from "./TrackSelectionBlock";
import styles from "./index.module.scss";
import BlockSession from "./BlockSession";
import { getFilteredClasses } from "../../../../../../utils/classUtils";

interface ITaskBlock {
    taksRecord: ISeminarTask;
    block: ISeminarTaskBlock;
    userSelection: any;
    task: string;
    eventId: string;
    status: string;
    language?: string;
    isTaskSelectingInProgress: boolean;
    setIsTaskSelectingInProgress: (value: boolean) => void;
    allUserSelections?: { [taskId: string]: any[] };
}

const TaskBlock = ({ block, userSelection, task, eventId, status, taksRecord, allUserSelections, ...props }: ITaskBlock) => {
    const { Task_Type__c } = block;
    const { isProgramTeam } = useSelector((state: any) => state.content);
    const isTaskCompleted = status === "Completed";

    const getSelectedClassOptinIds = () => {
        if (userSelection && userSelection.records.length > 0) {
            const classes = (taksRecord.Blocks__r?.records || []).flatMap((blockRecord) =>
                Array.isArray(blockRecord.Classes__r) ? blockRecord.Classes__r : []
            );
            return userSelection.records.map((record) => {
                const selectedOption = record.Selected_Option__c;
                const secondOption = record.Second_Option__c;

                const classId = classes.find((cls) =>
                    cls.HN_Session_title__c === selectedOption || cls.HN_Session_title__c === secondOption
                )?.Id;

                return {
                    userSelectionId: record.Id,
                    classId: classId || "",
                }
            });
        }
        return [];
    };

    const getSelectedClassTrackIds = () => {
        if (userSelection && userSelection.records.length > 0) {
            return userSelection.records.map((record) => {
                const selectedOption = record.Selected_Option__c;
                const secondOption = record.Second_Option__c;

                const selectedBlocks = taksRecord.Blocks__r?.records.filter((blockRecord) =>
                    blockRecord.Name === selectedOption || blockRecord.Name === secondOption
                );

                const classIds = selectedBlocks
                    ?.flatMap((blockRecord) => blockRecord.Classes__r?.map((cls) => cls.Id))
                    .filter((id) => !!id);
                const blockId = taksRecord.Blocks__r?.records.find((blockRecord) => blockRecord.Name === selectedOption)?.Id || "";

                return {
                    userSelectionId: record.Id,
                    classId: classIds || "",
                    blockId,
                }
            });
        }
        return [];
    };

    const getAllowSelectAll = {
        allowSelectAll: taksRecord.Allow_Select_All__c,
        minSelect: taksRecord.Min_Selection__c,
        maxSelect: taksRecord.Max_Selection__c,
    }

    const filteredClasses = getFilteredClasses(block, Task_Type__c, allUserSelections, taksRecord) || [];

    return Task_Type__c === "Track Selection" ? (
        <TrackSelectionBlock
            block={block}
            userSelection={userSelection}
            task={task}
            eventId={eventId}
            status={status}
            getSelectedClassTrackIds={getSelectedClassTrackIds}
            allowSelect={getAllowSelectAll}
            isProgramTeam={Boolean(isProgramTeam)}
            allUserSelections={allUserSelections}
            {...props}
        />
    ) : (
        <>
            <div className={styles.classWrapper}>
                {filteredClasses &&
                    filteredClasses.map((cls: IClasses, index: number) => {
                        return (
                            <BlockSession
                                key={index}
                                classes={cls}
                                type={Task_Type__c}
                                eventId={eventId}
                                task={block.Seminar_Task__c}
                                userSelection={userSelection}
                                isTaskCompleted={isTaskCompleted}
                                isProgramTeam={Boolean(isProgramTeam)}
                                getSelectedClassIds={getSelectedClassOptinIds}
                                allowSelect={getAllowSelectAll}
                                allUserSelections={allUserSelections}
                                {...props}
                            />
                        );
                    })}
            </div>
        </>
    )
};

export default TaskBlock;